import gql from "graphql-tag";

export const allStorages = gql`
  query allStorages {
    allStorages {
      nodes {
        id
        fileName
        fileSize
        fileType
        url
      }
    }
  }
`;

export const shipmentFiles = gql`
  query ShipmentFiles($id: Int) {
    allStorages(condition: { shipmentId: $id }) {
      nodes {
        id
        fileName
        fileSize
        fileType
        url
      }
    }
  }
`;

export const orderFiles = gql`
  query OrderFiles($id: Int) {
    allStorages(condition: { orderId: $id }) {
      nodes {
        id
        fileName
        fileSize
        fileType
        url
        orderId
      }
    }
  }
`;

export const carrierFiles = gql`
  query CarrierFiles($id: Int) {
    allStorages(condition: { carrierId: $id }) {
      nodes {
        id
        fileName
        fileSize
        fileType
        url
        carrierId
      }
    }
  }
`;

export const relationFiles = gql`
  query RelationFiles($id: Int) {
    allStorages(condition: { relationId: $id }) {
      nodes {
        id
        fileName
        fileSize
        fileType
        url
        relationId
      }
    }
  }
`;

export const contactFiles = gql`
  query ContactFiles($id: Int) {
    allStorages(condition: { contactId: $id }) {
      nodes {
        id
        fileName
        fileSize
        fileType
        url
        contactId
      }
    }
  }
`;

export const createStorage = gql`
  mutation(
    $name: String!
    $size: Int!
    $type: String!
    $fileUrl: String!
    $orderId: Int
    $relationId: Int
    $carrierId: Int
    $shipmentId: Int
    $contactId: Int
  ) {
    createStorage(
      input: {
        storage: {
          fileName: $name
          fileSize: $size
          fileType: $type
          url: $fileUrl
          orderId: $orderId
          relationId: $relationId
          carrierId: $carrierId
          shipmentId: $shipmentId
          contactId: $contactId
        }
      }
    ) {
      storage {
        id
        fileName
        fileSize
        fileType
        url
        orderId
        relationId
        carrierId
        shipmentId
        contactId
      }
    }
  }
`;

export const deleteStorageById = gql`
  mutation deleteStorageById($id: Int!) {
    deleteStorageById(input: { id: $id }) {
      id
      fileName
      fileSize
      fileType
      url
      orderId
      relationId
      carrierId
      shipmentId
      contactId
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/files.js